import React from 'react'
import "./addition.css"

const Addition = () => {
  return (
    <div className='add'>
    <div className="addList">
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/216475546.webp?k=b3803ba3bc1f5c3b481ac390a752a7a3787c58a2b5c5e2081ecdc1c81fc11cd0&amp;o=" alt="" className="addImg" />
        <div className="addItem">
            <span className="addName">La Roulotte de Ciney</span>
            <span className="addCity">Abuja, Nigeria</span>
        </div>
        <div className="addRating">
            <button className="addBtn">8.4</button>
            <span className="addcomment">Very Good . 89 reviews</span>
        </div>
    </div>
    <div className="addList">
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/280947638.webp?k=9e8f72c1ff91b261cdda3dbe4e1a70bef455dd72c00119ff379c671a65ad565d&amp;o=" alt="" className="addImg" />
        <div className="addItem">
            <span className="addName">Domki Wierszyki Shelters</span>
            <span className="addCity">Poland, Zakopane</span>
        </div>
        <div className="addRating">
            <button className="addBtn">9.7</button>
            <span className="addcomment">Exceptional . 87 reviews</span>
        </div>
    </div>
    <div className="addList">
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/131500906.webp?k=b6f638eadb7c9632498a9e9a15440987a22489684b8825b0cb235bd3c79f07de&amp;o=" alt="" className="addImg" />
        <div className="addItem">
            <span className="addName">Ranczo w Dolinie</span>
            <span className="addCity">Abuja, Nigeria</span>
        </div>
        <div className="addRating">
            <button className="addBtn">8.4</button>
            <span className="addcomment">Exceptional . 89 reviews</span>
        </div>
    </div>
    <div className="addList">
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/187853972.webp?k=dd753431cf4b638642614dc060512d832d24f3249eef30b9a5f18601d2ac5635&amp;o=" alt="" className="addImg" />
        <div className="addItem">
            <span className="addName">Tiny House Dreischwesternherz</span>
            <span className="addCity">Abuja, Nigeria</span>
        </div>
        <div className="addRating">
            <button className="addBtn">8.4</button>
            <span className="addcomment">Exceptional . 89 reviews</span>
        </div>
    </div>
    </div>
  )
}

export default Addition